module.exports = __webpack_public_path__ + "img/aston_martin.9e9a6c4e.png";